import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./home.css";
import HomeVideo from "./HomeVideo";

import { HashLink } from "react-router-hash-link";
import Modal from "../../components/Modal";

const Home = () => {
  const [image, setImage] = useState("/assets/homeimg1.jpg");

  const handleHover = (newImage) => {
    setImage(newImage);
  };
  const [activeNav, setActiveNav] = useState("#home");

  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    setShowModal(true);
  }, []);
  const navigate = useNavigate();

  const handleLinkClick = (link) => {
    navigate(link); // Navigate to the specified link
    window.location.reload(); // Refresh the page
  };

  return (
    <div id="home">
      {showModal && <Modal closeModal={closeModal} />}

      <div className="home_vid">
        <HomeVideo />
      </div>
      <div className="main_container container2">
        <div className="portp_div2 container">
          <div className="portp_div21">
            <span className="home_span">WHO WE ARE</span>
            <h2>
              Interconnecting infrastructure <br /> seamlessly
            </h2>
            <p>
              Crest Digitel is a leading Indian Digital Connectivity
              Infrastructure company backed by global parentage that is
              committed to providing innovative solutions. We are dedicated to
              revolutionizing people's lives by seamlessly connecting them
              anytime and anywhere.
            </p>
            <Link to="" onClick={() => handleLinkClick("/about-us")}>
              <button class="button-23 btn23" role="button">
                KNOW MORE
              </button>
            </Link>
          </div>
          <div className="portp_div31">
            <img src="/assets/crestgif2.gif" alt="" />
          </div>
        </div>

        <div className="portp_div2 gap_hp2  container home_div33">
          <div className="portp_div31 img_transition">
            <img src={image} alt="" />
          </div>
          <div className="portp_div21 ">
            <div className="portp_div21 gap_hp">
              <span className="home_span">OUR PORTFOLIO</span>
              <h2>Extensive network infrastructure</h2>
              <ul className="hp_li">
                <li
                  onMouseEnter={() => handleHover("/assets/homeimg1.jpg")}
                  onMouseLeave={() => handleHover("/assets/homeimg1.jpg")}
                >
                  <HashLink className="hashlink" to="/our-portfolio#port1">
                    In-Building Solution
                  </HashLink>
                </li>
                <li
                  onMouseEnter={() => handleHover("/assets/homeimg6.jpg")}
                  onMouseLeave={() => handleHover("/assets/homeimg6.jpg")}
                >
                  <HashLink className="hashlink" to="/our-portfolio#port2">
                    Small Cell Solution
                  </HashLink>
                </li>
                <li
                  onMouseEnter={() => handleHover("/assets/homeimg7.jpg")}
                  onMouseLeave={() => handleHover("/assets/homeimg7.jpg")}
                >
                  <HashLink className="hashlink" to="/our-portfolio#port3">
                    ResNet Solution
                  </HashLink>
                </li>
                <li
                  onMouseEnter={() => handleHover("/assets/homeimg8.jpg")}
                  onMouseLeave={() => handleHover("/assets/homeimg8.jpg")}
                >
                  <HashLink className="hashlink" to="/our-portfolio#port4">
                    BizNet Solution
                  </HashLink>
                </li>
              </ul>
            </div>
          </div>
        </div>

        
      <div className="portp_div2 container hp_color h_flex">
        <div className="portp_div21 ">
          <span className="home_span">OUR CULTURE</span>
          <h2>
            Embracing inclusion and <br className="hp_br1" />
            fostering expression
          </h2>
          <p className="home_div5p">
            Our organization is committed to creating an inclusive environment
            where everyone can realize their full potential.
          </p>
          <p>
            We nurture a growth culture in which our people can thrive, become
            future-fit, bring their best selves to work and connect with all
            levels of the organization, irrespective of their designation.
          </p>
          <Link to="" onClick={() => handleLinkClick("/life-at-crest")}>
            <button class="button-23 btn23 btn_m" role="button">
              KNOW MORE
            </button>
          </Link>
        </div>
        <div className="portp_div31">
          <img src="/assets/homeimg2.jpg" alt="" />
        </div>
      </div>
      </div>


      {/* <div className="portp_div2 home_div5">
        <div className="portp_div21 home_div51">
          <span className="home_span">OUR CULTURE</span>
          <h2>
            Embracing inclusion and <br className="hp_br1" />
            fostering expression
          </h2>
          <p className="home_div5p">
            Our organization is committed to creating an inclusive environment
            where everyone can realize their full potential.
          </p>
          <p>
            We nurture a growth culture in which our people can thrive, become
            future-fit, bring their best selves to work and connect with all
            levels of the organization, irrespective of their designation.
          </p>
          <Link to='' onClick={() => handleLinkClick("/life-at-crest")}>
          <button class="button-23 btn23" role="button">
            KNOW MORE
          </button>
          </Link>

        </div>
        <div className="portp_div31 home_div5_hide">
          <img src="/assets/homeimg2.jpg" alt="" />
        </div>
      </div> */}

      <div className="main_container container2 home_div6">
        <div className="home_div4">
          <div className="home_div41">
            <span className="home_span">OUR PROJECTS</span>
            <h2>Marquee Deployments Across Sectors</h2>
          </div>
          <div className="home_div42">
            <div className="home_div42_img">
              <Link onClick={() => handleLinkClick("/our-marquee-deployment")}>
                <img src="/assets/homeimg3.jpg" alt="" />
              </Link>
              <Link
                to=""
                onClick={() => handleLinkClick("/our-marquee-deployment")}
              >
                <h3>Metros</h3>
              </Link>
            </div>
            <div className="home_div42_img">
              <Link onClick={() => handleLinkClick("/our-marquee-deployment")}>
                <img src="/assets/homeimg4.jpg" alt="" />
              </Link>

              <Link onClick={() => handleLinkClick("/our-marquee-deployment")}>
                <h3>Airports</h3>
              </Link>
            </div>
            <div className="home_div42_img">
              <Link onClick={() => handleLinkClick("/our-marquee-deployment")}>
                <img src="/assets/homeimg5.jpg" alt="" />
              </Link>
              <Link onClick={() => handleLinkClick("/our-marquee-deployment")}>
                <h3>Retail and Institutional</h3>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
